import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Page not found", noindex: true });

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      <Zap size={40} className="text-mono/15" />
      <h1 className="mt-4 font-serif text-3xl text-ink">404</h1>
      <p className="mt-2 text-sm text-ink-light">
        This page doesn't exist, or the link may be broken.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-2xl bg-[#2b2b2d] px-8 py-3 text-xs tracking-wide text-white shadow-floating dark:bg-gold-500 dark:text-ink-dark dark:shadow-gold"
      >
        BACK TO HOME
      </Link>
    </div>
  );
}
